export const assert = <T>(x: T | null | undefined, message?: string): T => {
  if (!x) {
    throw new TypeError(message || `${x} was passed, expected truthy value`)
  }

  return x
}
